// extracted by mini-css-extract-plugin
module.exports = {"root":"HomeBanner_root__30Euk","image":"HomeBanner_image__1z7js","info":"HomeBanner_info__Jx0Jd","p":"HomeBanner_p__1TUE-","icon":"HomeBanner_icon__BH8RS"};